import {
  EmailTemplatesState,
  FETCH_EMAIL_TEMPLATES,
  FETCH_EMAIL_TEMPLATES_SUCCESS,
  FETCH_EMAIL_TEMPLATES_FAILURE,
  UPDATE_EMAIL_TEMPLATE,
  UPDATE_EMAIL_TEMPLATE_SUCCESS,
  UPDATE_EMAIL_TEMPLATE_FAILURE,
  PREVIEW_EMAIL_TEMPLATE,
  PREVIEW_EMAIL_TEMPLATE_SUCCESS,
  PREVIEW_EMAIL_TEMPLATE_FAILURE,
  FETCH_TEMPLATE_VARIABLES,
  FETCH_TEMPLATE_VARIABLES_SUCCESS,
  FETCH_TEMPLATE_VARIABLES_FAILURE,
  SELECT_TEMPLATE,
  CLEAR_PREVIEW,
  CLEAR_SAVE_STATUS,
  SET_TEMPLATE_FIELD,
} from './emailTemplatesTypes';
import { EmailTemplatesAction } from '../../Redux/EmailTemplates/actions';

const initialState: EmailTemplatesState = {
  templates: [],
  selectedTemplate: null,
  variables: [],
  previewResult: null,
  loading: false,
  error: null,
  correlationId: null,
  saving: false,
  saveSuccess: false,
  previewing: false,
};

export function emailTemplatesReducer(
  state: EmailTemplatesState = initialState,
  action: EmailTemplatesAction
): EmailTemplatesState {
  switch (action.type) {
    case FETCH_EMAIL_TEMPLATES:
      return { ...state, loading: true, error: null, correlationId: null };

    case FETCH_EMAIL_TEMPLATES_SUCCESS:
      return { ...state, loading: false, templates: action.payload };

    case FETCH_EMAIL_TEMPLATES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        correlationId: action.payload.correlationId || null,
      };

    case UPDATE_EMAIL_TEMPLATE:
      return { ...state, saving: true, saveSuccess: false, error: null, correlationId: null };

    case UPDATE_EMAIL_TEMPLATE_SUCCESS: {
      const updated = action.payload;
      return {
        ...state,
        saving: false,
        saveSuccess: true,
        selectedTemplate: updated,
        templates: state.templates.map((t) =>
          t.templateCode === updated.templateCode ? updated : t
        ),
      };
    }

    case UPDATE_EMAIL_TEMPLATE_FAILURE:
      return {
        ...state,
        saving: false,
        saveSuccess: false,
        error: action.payload.error,
        correlationId: action.payload.correlationId || null,
      };

    case PREVIEW_EMAIL_TEMPLATE:
      return { ...state, previewing: true, previewResult: null, error: null };

    case PREVIEW_EMAIL_TEMPLATE_SUCCESS:
      return { ...state, previewing: false, previewResult: action.payload };

    case PREVIEW_EMAIL_TEMPLATE_FAILURE:
      return {
        ...state,
        previewing: false,
        error: action.payload.error,
        correlationId: action.payload.correlationId || null,
      };

    case FETCH_TEMPLATE_VARIABLES:
      return { ...state, loading: true };

    case FETCH_TEMPLATE_VARIABLES_SUCCESS:
      return { ...state, loading: false, variables: action.payload };

    case FETCH_TEMPLATE_VARIABLES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        correlationId: action.payload.correlationId || null,
      };

    case SELECT_TEMPLATE:
      return {
        ...state,
        selectedTemplate: action.payload,
        previewResult: null,
        saveSuccess: false,
        error: null,
        correlationId: null,
      };

    case CLEAR_PREVIEW:
      return { ...state, previewResult: null };

    case CLEAR_SAVE_STATUS:
      return { ...state, saveSuccess: false, error: null, correlationId: null };

    case SET_TEMPLATE_FIELD: {
      if (!state.selectedTemplate) return state;
      return {
        ...state,
        selectedTemplate: {
          ...state.selectedTemplate,
          [action.payload.field]: action.payload.value,
        },
      };
    }

    default:
      return state;
  }
}
